import { Button, Column, Error as ErrorIcon } from 'hatch-components';
import styled from 'styled-components';

export const StyledDefaultTemplateError = styled(Column)(
  ({ theme: { spacing } }) => ({
    alignItems: 'center',
    flexWrap: 'nowrap',
    height: '100%',
    justifyContent: 'center',
    overflowY: 'auto',
    padding: spacing.md,
    width: '100%',
  }),
);

export const StyledDefaultTemplateErrorMessage = styled(Column)(() => ({
  alignItems: 'center',
  flexShrink: 0,
  height: 'auto',
  justifyContent: 'center',
  width: '100%',
}));

export const StyledError = styled(ErrorIcon)(({ theme: { colors } }) => ({
  circle: {
    stroke: colors.secondary,
  },
  path: {
    fill: colors.secondary,
  },
}));

export const StyledHeader = styled.h1(
  ({ theme: { colors, font, spacing } }) => ({
    color: colors.secondary,
    fontSize: font.size.md,
    fontWeight: font.weight.bold,
    lineHeight: font.size.lg,
    padding: `${spacing.md} 0 ${spacing.xs}`,
  }),
);

export const StyledSubHeader = styled.h2(
  ({ theme: { colors, font, spacing } }) => ({
    color: colors.secondary,
    fontSize: font.size.md,
    lineHeight: font.size.lg,
    paddingBottom: spacing.md,
  }),
);

export const StyledButton = styled(Button)(({ theme: { font, colors } }) => ({
  borderColor: colors.secondary,
  color: colors.secondary,
  fontSize: font.size.sm,
  fontWeight: font.weight.bold,
  lineHeight: font.lineHeight.sm,
}));
